import { render, staticRenderFns } from "./AppTable.vue?vue&type=template&id=b6eda9a6&scoped=true&"
import script from "./AppTable.vue?vue&type=script&lang=ts&"
export * from "./AppTable.vue?vue&type=script&lang=ts&"
import style0 from "./AppTable.vue?vue&type=style&index=0&id=b6eda9a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6eda9a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDataTable,VDivider,VPagination,VTextField})
